<template lang="pug">
.footer
  footer.text-white.bg-dark
    .container.text-center.py-4
      h4 Contact
      ul
        li
          a(href="tel:+886-2-87515191")
            font-awesome-icon.i_mr_1(
              :icon="['fas', 'phone']",
              data-toggle="tooltip",
              data-placement="left",
              :title="companyInformation.phone_number"
            ) 
            | {{ companyInformation.phone_number }}
        | &#32;
        li
          a.service(:href="'mailto:' + companyInformation.email")
            font-awesome-icon.fax_icon.i_mr_1(
              :icon="['fas', 'envelope']",
              :title="companyInformation.email"
            ) 
            | {{ companyInformation.email }}
        | &#32;
        li
          a.fax(:href="'mailto:' + companyInformation.fae_email")
            font-awesome-icon.i_mr_1(
              :icon="['fas', 'envelope']",
              :title="companyInformation.fae_email"
            ) 
            | {{ companyInformation.fae_email }}
      ul.mb-4
        li {{ companyInformation.address }}
        | &#32;
      h4 Follow Us
      .link
        a(:href="companyInformation.instagram_link", target="_blank")
          font-awesome-icon.svg-inline(:icon="['fab', 'linkedin-in']")
        | &#32;
        a(
          :href="companyInformation.youtube_link",
          target="_blank",
          style="padding-right: 0.5px"
        )
          font-awesome-icon.svg-inline(:icon="['fab', 'youtube']")
    .copyright.py-2.d-flex.justify-content-center
      | {{ companyInformation.copyright }}
  .cookies.py-2.shadow(v-if="cookiesShow")
    .container
      .row.align-items-center
        .col-md-8
          p.mb-0
            | We use cookies on this site to enhance your user experience By clicking any link on this page you are giving your consent for us to set cookies. 
            a(v-b-modal.modal-scrollable="", @click="showTextDialog(1)", style="text-decoration: underline;") Privacy Policy
        .col-md-4.text-right
          a.btn.btn-primary.btn-sm.px-4(
            @click="closeCookies",
            style="margin-right: 4px"
          ) Accept

  dialog-text(:title="dialogTitle", :divider="false", :contentCenter="false")
    template(#content) 
      p(style="margin: 0")
        small(v-html="dialogContent")
</template>

<script>
import { getCompanyInformation } from "@/api/company";
import DialogText from "@/components/common/DialogText";
import { getLoginInformation } from "@/api/login";

export default {
  name: "Footer",
  components: {
    DialogText,
  },
  data() {
    return {
      companyInformation: {},
      cookiesShow: true,
      //如果沒有按過cookies按鈕 則會顯示cookiesShow
      //cookiesShow: localStorage.getItem('cookiesAccepted') !== 'false',
      dialogTitle: "",
      dialogContent: "",
      dialogTexts: [
        {
          title: "Terms & Conditions",
          content: "",
        },
        {
          title: "Privacy Policy",
          content: "",
        },
      ],
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getCompanyInformation();
      this.getLoginInformation();
    },
    sendCompanyInfo() {
      this.$emit("getCompanyInfo", this.companyInformation);
    },
    getCompanyInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getCompanyInformation(temp).then((response) => {
        this.companyInformation = response.data;
        this.sendCompanyInfo();
      });
    },
    getLoginInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getLoginInformation(temp).then((response) => {
        this.dialogTexts[0].content = response.data.terms_condition;
        this.dialogTexts[1].content = response.data.privacy_policy;
      });
    },
    closeCookies() {
      this.cookiesShow = false;
      localStorage.setItem('cookiesAccepted', 'false');
    },
    showTextDialog(type) {
      this.dialogTitle = this.dialogTexts[type].title;
      this.dialogContent = this.dialogTexts[type].content;
      this.$bvModal.show("textModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/banner";

.bg-dark {
  background-color: #082b6b !important;
}

.cookies {
  position: fixed;
  z-index: 99;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background-color: white;
  color: #082b6b;

  p {
    font-size: 0.875rem;
  }
}

.btn-primary {
  background-color: #082b6b;
  border-color: #082b6b;
}

.btn-outline-primary {
  color: #082b6b;
  border-color: #082b6b;
}

footer {
  .link {
    a {
      text-align: center;
      display: inline-block;
      background-color: white;
      border: 1.5px solid white;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      padding: 7px 0;
      margin-right: 10px;
      font-size: 1.5rem;
      color: #082b6b;
      transition: all 0.3s;
    }

    a:last-child {
      margin-right: 0px;
    }
  }

  ul {
    padding-left: 0;
    list-style: none;

    li {
      display: inline-block;

      &::after {
        content: "";
        border-right: 1px solid rgba(255, 255, 255, 0.15);
        margin-left: 10px;
        margin-right: 10px;
      }

      i {
        margin-right: 5px;
      }
    }

    li:last-child {
      &::after {
        display: none;
      }
    }
  }

  .copyright {
    background-color: rgba(0, 0, 0, 0.4);
  }

  h4 {
    color: white;
  }

  a {
    color: white;

    &:hover {
      color: #faad00;
    }
  }

  .service {
    position: relative;

    &::after {
      content: "S";
      position: absolute;
      top: 1;
      left: 3px;
      color: #082b6b;
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
    }
  }

  .fax {
    position: relative;

    &::after {
      content: "F";
      position: absolute;
      top: 1;
      left: 3px;
      color: #082b6b;
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
    }
  }

  footer .copyright {
    background-color: rgba(0, 0, 0, 0.4);
  }
}

.fa-youtube,
.fa-linkedin-in {
  vertical-align: -0.1em;
}

.fa-youtube {
  margin-left: 1px;
}

.svg-inline {
  vertical-align: -0.125em;
}

@media only screen and (max-width: 959px) {
  footer {
    .link {
      padding-bottom: 1rem !important;
      padding-top: 1rem !important;
      text-align: center;
    }

    .copyright {
      padding-left: 1rem;
      padding-right: 1rem;
      padding-bottom: 4rem !important;
      text-align: center;
    }
  }

  .cookies .col-md-4 {
    text-align: center !important;
    margin-top: 1rem;
  }
}
</style>
